<template>
	<span class="app-badge" v-bind="{ ...$attrs, ...badgeAttrs }" :role="isClickable ? 'button' : 'status'" :tabindex="isClickable ? 0 : undefined" :aria-live="!isClickable ? 'polite' : undefined" :aria-label="isClickable ? ariaLabel : undefined" @click="isClickable && handleClick()" @keyup.enter.prevent="isClickable && handleClick()" @keyup.space.prevent="isClickable && handleClick()">
		<slot>
			<template v-if="hasCount">{{ count }}</template>
			<template v-else>{{ text }}</template>
		</slot>
	</span>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "AppBadge",
	inheritAttrs: false, // para poder fusionar $attrs con badgeAttrs

	props: {
		text: { type: String, default: "" },
		count: { type: [Number, String], default: null },
		variant: {
			type: String,
			default: "primary",
			validator: (v) => ["primary", "success", "accent", "warning", "error", "info"].includes(v),
		},
		size: {
			type: String,
			default: "medium",
			validator: (s) => ["small", "medium", "large"].includes(s),
		},
		isClickable: { type: Boolean, default: false },
		ariaLabel: { type: String, default: "" },
		isDot: { type: Boolean, default: false },
	},

	computed: {
		hasCount() {
			return this.count !== null && this.count !== "";
		},
		badgeAttrs() {
			// detectar presencia de atributos <AppBadge small /> o <AppBadge large />
			const hasSmall = "small" in this.$attrs;
			const hasLarge = "large" in this.$attrs;

			const explicitSize = hasSmall ? "small" : hasLarge ? "large" : this.size;

			const attrs = {
				[this.variant]: "",
				...(explicitSize !== "medium" ? { [explicitSize]: "" } : {}),
			};

			if (this.isDot) attrs.dot = "";
			if (this.isClickable) attrs.clickable = "";

			return attrs;
		},
	},

	methods: {
		handleClick() {
			this.$emit("click");
		},
	},
});
</script>
